



















































































































import { Component, Vue, Prop } from "vue-property-decorator";
import ProcessoModel, { ProcessoDados } from "@/models/Processo";
import { getModule } from "vuex-module-decorators";
import { store, UserModule } from "@/store";
import firebase from "firebase";
import { UserDb } from "../models/User";
import _debug from "debug";

const debug = _debug("Mediacao:components:ProcessosList.vue");

const userModule = getModule(UserModule, store);

@Component({
    components: {},
})
export default class ProcessosList extends Vue {
    @Prop() public carregando!: boolean;
    @Prop() public processos!: ProcessoModel[];
    @Prop() public podeAdicionar!: boolean;
    @Prop() public podeEditar!: boolean;
    @Prop() public poderPegarProcesso!: boolean;
    @Prop({ default: "Processos" }) public titulo!: string;
    @Prop({ default: false }) public mostraMediador!: boolean;
    @Prop({ default: "" }) public emailMediador!: string;

    private dialogTomarProcesso = false;
    private processoSelecionado?: ProcessoModel;

    public corMediador(processo: ProcessoModel) {
        if (processo.partes && processo.partes.mediador && processo.partes.mediador.email && processo.partes.mediador.email === this.emailMediador) {
            return "green";
        } else {
            return "blue";
        }
    }

    private classePorStatus(processo: ProcessoModel) {
        let classe = "";
        if (processo) {
            classe = processo.status;
        }
        return classe;
    }

    abrirDialogoPegarProcesso(processo: ProcessoModel) {
        this.dialogTomarProcesso = true;
        this.processoSelecionado = processo;
    }
    cancelarDialogoPegarProcesso() {
        this.dialogTomarProcesso = false;
        this.processoSelecionado = undefined;
    }

    public adiciona() {
        debug("adicionando...");
        this.$emit("adicionarProcesso");
    }

    public editar(processo: ProcessoModel) {
        this.$emit("editar", processo);
    }

    public visualizar(processo: ProcessoModel) {
        this.$emit("visualizarProcesso", processo);
    }

    public pegarProcesso() {
        debug("pegar processo no filho", this.processoSelecionado);
        this.$emit("pegarProcesso", this.processoSelecionado);
    }
}
